module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#youtube",
      toString: function () {
        return this.url;
      }
    }